import { useCallback, useEffect, useState } from 'react';

import { electronApis } from '@/features/electron-api';
import { AppCapability, isCapable } from '@/utils/capabilities';

export default function useAutoStart() {
  const [status, setStatus] = useState<boolean | null>(null);

  const checkAutoStartState = useCallback(async () => {
    if (!isCapable(AppCapability.StartupAtLogin)) return;

    try {
      setStatus(await electronApis.system.getAutoStartStatus());
    } catch (error) {
      console.error('Failed to get auto-start status:', error);
      setStatus(false);
    }
  }, []);

  const enableAutoStart = useCallback(async () => {
    if (!isCapable(AppCapability.StartupAtLogin)) return;

    try {
      await electronApis.system.enableAutoStart();
      await checkAutoStartState();
    } catch (error) {
      console.error('Failed to enable auto-start:', error);
      throw error;
    }
  }, [checkAutoStartState]);

  const disableAutoStart = useCallback(async () => {
    if (!isCapable(AppCapability.StartupAtLogin)) return;

    try {
      await electronApis.system.disableAutoStart();
      await checkAutoStartState();
    } catch (error) {
      console.error('Failed to disable auto-start:', error);
      throw error;
    }
  }, [checkAutoStartState]);

  useEffect(() => {
    checkAutoStartState();
  }, [checkAutoStartState]);

  return {
    status,
    enable: enableAutoStart,
    disable: disableAutoStart,
  };
}
